import React from "react";
import { Link } from "gatsby";

import imgL1Logo from "../../assets/ecom/logo_black.png";
import imgL1LogoWhite from "../../assets/ecom/logo_white.png";

const Logo = ({ white, height, className = "", ...rest }) => {
  return (
    <Link to="/" className={`d-block ${className}`} {...rest}>
      {white ? (
        <img src={imgL1LogoWhite} width="100px" alt="" />
      ) : (
        <img src={imgL1Logo} width="100px" alt="" />
      )}
    </Link>
  );
};

export default Logo;
